import { takeLatest, call, put } from 'redux-saga/effects';
import dataApi from '../../apis/dataApi';
import * as constants from './constants';
import * as actions from './actions';
import handleError from '../handleError';

export function* fetchUtensils() {
  try {
    const response = yield call(dataApi.fetchUtensils);
    yield put(actions.fetchUtensilsDone(response.data));
  } catch (error) {
    yield call(
      handleError,
      error,
      'notify.utensilsFetchFail',
      put(actions.fetchUtensilsFail(error))
    );
  }
}

export function* fetchMarketUtensils(action) {
  try {
    const marketCode = action.payload;
    const response = yield call(dataApi.fetchMarketUtensils, marketCode);
    yield put(actions.fetchMarketUtensilsDone(response.data));
  } catch (error) {
    yield call(
      handleError,
      error,
      'notify.utensilsFetchFail',
      put(actions.fetchMarketUtensilsFail(error))
    );
  }
}

export default [
  takeLatest(constants.FETCH_UTENSILS, fetchUtensils),
  takeLatest(constants.FETCH_MARKET_UTENSILS, fetchMarketUtensils)
];
